import { ReactNode } from "react";

interface HelmetProps {
  children: ReactNode;
}

export function Helmet({ children }: HelmetProps) {
  return <>{children}</>;
}